/*
    @module state
    Providing values in state object as data source
 */
define('shared/util/providers/data/state',['shared/util/registers/DataProvider', 'shared/lib/RSVP', 'shared/lib/Emitter', 'shared/util/state', 'shared/util/state/adapters/onChange'],
function( DataProvider, RSVP, Emitter, state, onChangeAdapter ){
    'use strict';

    var providers = {};
    var done;

    function createProvider( key, value ){
    
        if (providers[key] == null) {
            var provider = {
                id: key,
                value: function(){
                    return this._value;
                },
                _value: value
            };
            
            DataProvider.instance.register( provider );
            providers[key] = provider;
        }
        else {
            providers[key]._value = value;   
        }
        return providers[key];
    }

    return {
        provide: function(){
            if ( done ) {
                return done;
            }

            done = RSVP.resolve()
                .then(function(){
                    return state.adapters.add(onChangeAdapter);
                })
                .then(function(){
                    return state.get('');
                })
                .then(function( values ){
                    var root = values[0];
                    for( var key in root ) (function(key){
                        if ( !root.hasOwnProperty(key) ) {
                            return;
                        }

                        createProvider(key, root[key]);
                    })(key);
                        
                })
                .then(function(){
                    // monitor future changes
                    onChangeAdapter.on('change', function( key, value ){
                        if ( key == null ) {
                            return;
                        }
                        
                        var keys = key.split('.');
                        var first = keys[0];
                        var promise;

                        if (first == null || first === '') {
                            return;
                        }

                        if ( providers[first] == null ) {
                            promise = state.get(first)
                                .then(function(values){
                                    createProvider( first, values[0] );
                                });
                        }
                        else {
                            promise = RSVP.resolve();
                        }

                        promise.then(function(){
                            if ( first == key && providers[first].value() != value ){
                                // means updating the root element
                                createProvider( first, value );
                            }

                            providers[first].emit( 'change', key, value );
                        });
                        
                    });
                });

            return done;
        }
    };
    
});
